import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const resetUnlinkedItems = (organizationId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'RESETTING_UNLINKED_ITEMS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/reset-unassociated-items-page`,
            null,
            {
              params: {
                'request-id': reqId,
                organizationId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'RESETTING_UNLINKED_ITEMS_DONE',
              payload: {
                promptId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            dispatch({
              type: 'RESETTING_UNLINKED_ITEMS_FAILED',
              payload: `Failed to reset unlinked items`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'RESETTING_UNLINKED_ITEMS_FAILED',
            payload: `Failed to reset unlinked items`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'RESETTING_UNLINKED_ITEMS_FAILED',
        payload: `Failed to reset unlinked items`,
      });
    }
  };
};

export default resetUnlinkedItems;
